module.exports = __webpack_public_path__ + "img/thumb-cd.3bc016b2.jpeg";